<ion-content force-overscroll="false">
  <div class="container">
    <ion-datetime mode="md" presentation="date" [min]="minDate ? minDate.toISOString() : undefined"
      [max]="maxDate ? maxDate.toISOString() : undefined" (ngModelChange)="close($event)"
      [ngModel]="value ? value.toISOString() : maxDate ? maxDate.toISOString() : minDate ? minDate.toISOString() : undefined">
    </ion-datetime>
  </div>
</ion-content>
